import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";

export function formatCurrencyAndRoundUp(amount: number): string {
  return (Math.ceil(amount * 100) / 100).toFixed(2);
}

/**
 * Lightweight helper method to format prices as whole number or with decimal
 * Amount coming from Salesforce -> Plans API are already rounded off in 2 decimal places
 * We want the downstream services to round off these values - dangerous to do maths in JS without a third-party library
 */
export const formatWholeOrDecimalCurrency = (amount?: number): string => {
  if (amount === undefined) {
    return "";
  } else if (amount === Math.floor(amount)) {
    return Math.trunc(amount).toString();
  } else {
    return amount.toFixed(2);
  }
};

export function sanitisePhone(phone: string): string {
  return phone.replace(/[^a-zA-Z0-9]/g, "");
}

export function formatPhone(phone: string): string {
  if (!phone.match(/^[0-9]{10}$/)) {
    return phone;
  }
  const parsedPhone = PhoneNumberUtil.getInstance().parse(phone, "AU");
  return PhoneNumberUtil.getInstance().format(
    parsedPhone,
    PhoneNumberFormat.NATIONAL
  );
}

export function titlecase(str: string): string {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
